import { graphql } from '@/gql';
import type { GetNumberOfRidesPerUserQueryVariables } from '@/gql/graphql';
import { queryExecute } from '@/Utils/graphqlAPI';

export const getNumberOfRidesPerUser = async ({
  callerName,
  status,
  startDate,
  endDate,
  partnerId,
  pagination,
}: GetNumberOfRidesPerUserQueryVariables) => {
  const response = await queryExecute({
    query: graphql(`
      query GetNumberOfRidesPerUser(
        $partnerId: Float!
        $callerName: String
        $status: String
        $startDate: String
        $endDate: String
        $pagination: PaginationInputType
      ) {
        getNumberOfRidesPerUser(
          partnerId: $partnerId
          callerName: $callerName
          status: $status
          startDate: $startDate
          endDate: $endDate
          pagination: $pagination
        ) {
          count
          rows {
            numberOfRides
            callerName
            callerId
            phoneNumber
            partnerTotal
            partnerCredits
            partnerCosts
            homeAddress
          }
        }
      }
    `),
    variables: {
      callerName,
      status,
      startDate,
      endDate,
      partnerId,
      pagination,
    },
    fetchPolicy: 'no-cache',
  });

  return response.data.getNumberOfRidesPerUser;
};
